import { invoke } from '@tauri-apps/api/core'

import {
  getApiSettings,
  setApiSettings,
  clearApiSettings,
} from './api-settings'
import { singAndSendPathfinderSwapTransaction } from './pathfinder'
import {
  signPlainTransaction,
  signAndSendPlainTransaction,
  signPermit,
  signTransaction,
  signTransactions,
  buildAndSignSwapTransaction,
  buildSignAndSendSwapTransaction,
  bulkBuildSignAndSendSwapTransaction,
} from './signature'
import {
  exportWallet,
  getWallets,
  importWallet,
  removeWallet,
  generateMnemonic,
  createWallet,
  verifyPassword,
  unlock,
  lock,
  session,
  initialize,
  changePassword,
  hasWallets,
  findClosestSenderLocation,
  warmSenderConnection,
} from './wallet'

import type { SecureStorageService } from '../secure-storage-service'

export async function ping(value: string): Promise<string> {
  return await invoke<{ value: string }>('ping', {
    payload: {
      value,
    },
  }).then((r) => r.value)
}

export {
  changePassword,
  createWallet,
  generateMnemonic,
  exportWallet,
  getWallets,
  verifyPassword,
  session,
  importWallet,
  lock,
  removeWallet,
  unlock,
  initialize,
} from './wallet'

export { signTransaction } from './signature'

export const TauriSecureStorageService: SecureStorageService = {
  exportWallet,
  importWallet,
  removeWallet,
  getWallets,
  signTransaction,
  signTransactions,
  signPlainTransaction: signPlainTransaction,
  signAndSendPlainTransaction,
  generateMnemonic,
  createWallet,
  verifyPassword,
  unlock,
  lock,
  session,
  signPermit,
  initialize,
  changePassword,
  hasWallets,
  buildAndSignSwapTransaction,
  buildSignAndSendSwapTransaction,
  bulkBuildSignAndSendSwapTransaction,
  findClosestSenderLocation,
  warmSenderConnection,
  singAndSendPathfinderSwapTransaction,
  getApiSettings,
  setApiSettings,
  clearApiSettings,
}
